<script setup>
import HeaderActions from './HeaderActions.vue';
import { computed } from 'vue';

const props = defineProps({
  avatarUrl: {
    type: String,
    default: '',
  },
  introHeading: {
    type: String,
    default: '',
  },
  introBody: {
    type: String,
    default: '',
  },
  showPopoutButton: {
    type: Boolean,
    default: false,
  },
});

const containerClasses = computed(() => [
  props.avatarUrl ? 'justify-between' : 'justify-end',
]);
</script>

<template>
  <header
    class="header-expanded pb-4 px-5 relative box-border w-full bg-transparent"
  >
    <div class="flex items-start" :class="containerClasses">
      <img
        v-if="avatarUrl"
        class="h-10 rounded-full"
        :src="avatarUrl"
        alt="Avatar"
      />
      <HeaderActions
        :show-popout-button="showPopoutButton"
        :show-end-conversation-button="false"
        :show-delete-button="false"
      />
    </div>
    <h2
      v-dompurify-html="introHeading"
      class="mt-20 text-3xl font-large text-white/50 font-medium"
    />
    <p
      v-dompurify-html="introBody"
      class="text-3xl leading-normal text-white font-medium mb-10"
    />
  </header>
</template>
